(() => {
  const sectionScript = document.currentScript;
  if (!sectionScript || typeof Swiper === 'undefined') return;

  const sectionId = sectionScript.dataset.sectionId;
  const sectionRoot = document.getElementById(`shopify-section-${sectionId}`);
  const swiperElement = sectionRoot?.querySelector('.fvSwiper');
  if (!sectionRoot || !swiperElement) return;

  const registry = window.__topFvSectionRegistry || (window.__topFvSectionRegistry = {});
  if (registry[sectionId]) registry[sectionId]();

  const showPagination = sectionScript.dataset.showPagination === 'true';
  const prevButton = sectionRoot.querySelector('.swiper-button-prev');
  const nextButton = sectionRoot.querySelector('.swiper-button-next');
  const pagination = sectionRoot.querySelector('.swiper-pagination');
  const options = {
    loop: true,
    lazyPreloadPrevNext: 1,
    autoplay: {
      delay: Number(sectionScript.dataset.interval),
      disableOnInteraction: false
    },
    speed: Number(sectionScript.dataset.speed),
    on: {
      slideChange() {
        if (this.pagination) {
          this.pagination.render();
          this.pagination.update();
        }
      }
    }
  };

  if (showPagination) {
    options.pagination = {
      el: pagination,
      clickable: true,
      type: 'bullets',
      dynamicBullets: false
    };
    options.navigation = {
      nextEl: nextButton,
      prevEl: prevButton
    };
  }

  const swiper = new Swiper(swiperElement, options);

  const moveNavigationButtons = () => {
    const navigationWrapper = swiperElement.querySelector('.swiper-navigation-wrapper');
    const overlayTexts = swiperElement.querySelectorAll('.fv-slide-overlay-text');
    if (!prevButton || !nextButton || !navigationWrapper) return;

    if (window.innerWidth <= 750) {
      overlayTexts.forEach((overlayText) => {
        if (overlayText.querySelector('.swiper-button-prev')) return;

        const prevClone = prevButton.cloneNode(true);
        const nextClone = nextButton.cloneNode(true);
        prevClone.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          swiper.slidePrev();
        });
        nextClone.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          swiper.slideNext();
        });
        overlayText.appendChild(prevClone);
        overlayText.appendChild(nextClone);
      });
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
      return;
    }

    overlayTexts.forEach((overlayText) => {
      overlayText.querySelector('.swiper-button-prev')?.remove();
      overlayText.querySelector('.swiper-button-next')?.remove();
    });
    prevButton.style.display = '';
    nextButton.style.display = '';
  };

  const cleanup = () => {
    window.removeEventListener('resize', moveNavigationButtons);
    document.removeEventListener('shopify:section:unload', handleSectionUnload);
    swiper.destroy(true, true);
    delete registry[sectionId];
  };
  const handleSectionUnload = (event) => {
    if (event.target?.id === `shopify-section-${sectionId}`) cleanup();
  };

  moveNavigationButtons();
  window.addEventListener('resize', moveNavigationButtons);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
  registry[sectionId] = cleanup;
})();
